<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Chance Beginning</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#one-month-later-chicago">One Month Later Chicago</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chicago-tribune">Chicago Tribune</a></li>
<li id="toc-li-6"><a href="#/text/ch006#duluth">Duluth</a></li>
<li id="toc-li-7"><span href="#/text/ch007#chicago" title="Link target outside of Sample">Chicago</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chicago-1" title="Link target outside of Sample">Chicago</span></li>
<li id="toc-li-9"><span href="#/text/ch009#grand-marais" title="Link target outside of Sample">Grand Marais</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chicago-2" title="Link target outside of Sample">Chicago</span></li>
<li id="toc-li-11"><span href="#/text/ch011#grand-marais-1" title="Link target outside of Sample">Grand Marais</span></li>
<li id="toc-li-12"><span href="#/text/ch012#duluth-tribune" title="Link target outside of Sample">Duluth Tribune</span></li>
<li id="toc-li-13"><span href="#/text/ch013#seattle" title="Link target outside of Sample">Seattle</span></li>
<li id="toc-li-14"><span href="#/text/ch014#mexico" title="Link target outside of Sample">Mexico</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chicago-3" title="Link target outside of Sample">Chicago</span></li>
<li id="toc-li-16"><span href="#/text/ch016#seattle-1" title="Link target outside of Sample">Seattle</span></li>
<li id="toc-li-17"><span href="#/text/ch017#three-months-later-mexico" title="Link target outside of Sample">Three Months Later Mexico</span></li>
<li id="toc-li-18"><span href="#/text/ch018#canada" title="Link target outside of Sample">Canada</span></li>
<li id="toc-li-19"><span href="#/text/ch019#it-comes-together" title="Link target outside of Sample">It Comes Together</span></li>
<li id="toc-li-20"><span href="#/text/ch020#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?640f9e43